const namedFormats = {
  date: {
    // 1:03 PM
    time: { hour: 'numeric', minute: 'numeric' },

    // Thursday
    dow: { weekday: 'long' },

    // Thursday 1:03 PM
    'dow-time': { weekday: 'long', hour: 'numeric', minute: 'numeric' },

    // Thu
    'dow-short': { weekday: 'short' },

    // January
    month: { month: 'long' },

    // Jan
    'month-short': { month: 'short' },

    // 2003
    year: { year: 'numeric' },

    // 1/2/2003
    short: { year: 'numeric', month: 'numeric', day: 'numeric' },

    // 1/2/03
    'short-w-2-digit-year': { year: '2-digit', month: 'numeric', day: 'numeric' },

    // 1/2/2003, 4:05 AM
    'short-w-time': { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' },

    // 1/2/03, 4:05 AM
    'short-w-time-2-digit-year': {
      year: '2-digit',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },

    // Thursday, 1/2/2003
    'short-w-dow': { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' },

    // Jan 2, 2003
    medium: { year: 'numeric', month: 'short', day: 'numeric' },

    // Jan 2
    'medium-no-year': { month: 'short', day: 'numeric' },

    // Jan 2003
    'medium-no-day': { year: 'numeric', month: 'short' },

    // Thue, Jan 2, 2020
    'medium-w-dow': { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' },

    // Thu, Jan 2
    'medium-w-dow-no-year': { weekday: 'short', month: 'short', day: 'numeric' },

    // Thu, Jan 2
    'medium-w-long-dow-no-year': { weekday: 'long', month: 'short', day: 'numeric' },

    // Thu, Jan 2, 2020 4:05 AM
    'medium-w-dow-time': {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },

    // Thu, Jan 2, 4:05 AM
    'medium-w-dow-time-no-year': {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },

    // Jan
    'medium-month-only': { month: 'short' },

    // January 2, 2003
    long: { year: 'numeric', month: 'long', day: 'numeric' },

    // January 2
    'long-no-year': { month: 'long', day: 'numeric' },

    // January 2003
    'long-no-day': { year: 'numeric', month: 'long' },

    // Thursday, January 2, 2003
    'long-w-dow': { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },

    // Thursday, January 2, 2003, 4:05 AM
    'long-w-dow-time': {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },

    // Thursday, January 2, 4:05 AM
    'long-w-dow-time-no-year': { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' },
  },
  time: {
    short: {
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  number: {
    decimal: { style: 'decimal' },
    percent: { style: 'percent' },
    percentOneFractionDigit: { style: 'percent', maximumFractionDigits: 1 },
    currency: { style: 'currency' },
    // $46
    'currency-short': {
      style: 'currency',
      minimumFractionDigits: '0',
      maximumFractionDigits: '0',
    },
    'one-decimal': {
      style: 'decimal',
      minimumFractionDigits: '1',
      maximumFractionDigits: '1',
    },
  },
};

export default namedFormats;
